var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { combine } from 'zustand/middleware';
import { checkObjectIsNotEmpty } from 'common/helpers/check-object-is-not-empty';
export function baseActions(initialValues) {
    return combine(initialValues, function (setState, getState) { return ({
        getInitialized: function () {
            var state = getState();
            return state.initialized;
        },
        getSearchString: function () {
            var state = getState();
            return state.searchString || '';
        },
        getIsOpenModalFilter: function () {
            var state = getState();
            return state.isOpenModalFilter;
        },
        getModalFilterValues: function () {
            var state = getState();
            return state.modalFilterValues;
        },
        getPageContent: function () {
            var state = getState();
            return state.content;
        },
        getIsNotEmptyModalFilterValues: function () {
            var state = getState();
            return checkObjectIsNotEmpty(state.modalFilterValues);
        },
        getPageSize: function () {
            var state = getState();
            return state.pageSize;
        },
        getIsEndOfTheListReached: function () {
            var state = getState();
            return state.isEndOfTheListReached;
        },
        setPageContent: function (value) {
            setState(function (state) { return (__assign(__assign({}, state), { loading: false, initialized: true, content: value })); });
        },
        setTotalPages: function (value) {
            setState(function (state) { return (__assign(__assign({}, state), { totalPages: value })); });
        },
        setPageLazyContent: function (value, isEndOfTheListReached) {
            setState(function (state) { return (__assign(__assign({}, state), { content: state.currentPage !== 0 && Array.isArray(value) && Array.isArray(state.content)
                    ? __spreadArray(__spreadArray([], state.content, true), value, true) : value, loading: false, initialized: true, isEndOfTheListReached: isEndOfTheListReached !== null && isEndOfTheListReached !== void 0 ? isEndOfTheListReached : (Array.isArray(value) && value.length < state.pageSize) })); });
        },
        setInitialized: function (value) {
            setState(function (state) { return (__assign(__assign({}, state), { initialized: value })); });
        },
        setLoading: function (value) {
            setState(function (state) { return (__assign(__assign({}, state), { loading: value })); });
        },
        setPageMeta: function (_a) {
            var total = _a.total;
            setState(function (state) { return (__assign(__assign({}, state), { total: total, totalPages: Math.ceil((total || 1) / (state.pageSize || 1)), showControllers: total > initialValues.pageSize })); });
        },
        setListPageContent: function (value, pageMeta) {
            setState(function (state) { return (__assign(__assign({}, state), { content: value, total: pageMeta.total, totalPages: Math.ceil((pageMeta.total || 1) / pageMeta.pageSize), currentPage: pageMeta.page, pageSize: pageMeta.pageSize, loading: false, initialized: true, showControllers: pageMeta.total > initialValues.pageSize })); });
        },
        setError: function (value) {
            setState(function (state) { return (__assign(__assign({}, state), { loading: false, initialized: true, error: value, content: initialValues.content, total: initialValues.total, totalPages: initialValues.totalPages, showControllers: false })); });
        },
        getCurrentPage: function () {
            var state = getState();
            return state.currentPage;
        },
        changeSearchString: function (value) {
            setState(function (state) { return (__assign(__assign({}, state), { searchString: value, currentPage: initialValues.currentPage })); });
        },
        openFilterModal: function () {
            setState(function (state) { return (__assign(__assign({}, state), { isOpenModalFilter: true })); });
        },
        closeFilterModal: function () {
            setState(function (state) { return (__assign(__assign({}, state), { isOpenModalFilter: false })); });
        },
        setModalFilterValues: function (value) {
            setState(function (state) { return (__assign(__assign({}, state), { modalFilterValues: value, currentPage: initialValues.currentPage })); });
        },
        resetModalFilterValues: function () {
            setState(function (state) { return (__assign(__assign({}, state), { modalFilterValues: initialValues.modalFilterValues, currentPage: initialValues.currentPage })); });
        },
        resetModalFilterField: function (value) {
            setState(function (state) {
                var _a;
                return (__assign(__assign({}, state), { modalFilterValues: __assign(__assign({}, state.modalFilterValues), (_a = {}, _a[value] = initialValues.modalFilterValues[value], _a.currentPage = initialValues.currentPage, _a)) }));
            });
        },
        removeModalFilterField: function (value) {
            setState(function (state) {
                var _a;
                return (__assign(__assign({}, state), { modalFilterValues: __assign(__assign({}, state.modalFilterValues), (_a = {}, _a[value] = null, _a)) }));
            });
        },
        removeSelectedFieldValue: function (field, value) {
            setState(function (state) {
                var _a;
                return (__assign(__assign({}, state), { modalFilterValues: __assign(__assign({}, state.modalFilterValues), (_a = {}, _a[field] = state.modalFilterValues[field].filter(function (el) { return el !== value; }), _a.currentPage = initialValues.currentPage, _a)) }));
            });
        },
        setCurrentPage: function (value) {
            setState(function (state) { return (__assign(__assign({}, state), { currentPage: value })); });
        },
        setPageSize: function (value) {
            setState(function (state) { return (__assign(__assign({}, state), { pageSize: value, currentPage: initialValues.currentPage })); });
        },
        setIsEndOfTheListReached: function (value) {
            setState(function (state) { return (__assign(__assign({}, state), { isEndOfTheListReached: value })); });
        },
        nextPage: function () {
            setState(function (state) { return (__assign(__assign({}, state), { currentPage: state.currentPage + 1 })); });
        },
        resetPageContent: function () {
            setState(function (state) { return (__assign(__assign({}, state), { content: initialValues.content, loading: initialValues.loading, initialized: initialValues.initialized, currentPage: initialValues.currentPage })); });
        },
        resetState: function () {
            setState(function () { return initialValues; });
        },
    }); });
}
